import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { logoutFromServer } from "../../utilities/AuthService";
import { unregisterFcmToken } from "../../utilities/firebaseMessaging";

const Logout = () => {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);

	const handleLogout = async () => {
		setIsLoading(true);
		try {
			await unregisterFcmToken();
		} catch (error) {
			console.error("FCM token unregister failed:", error);
		} finally {
			await logoutFromServer();
			navigate("/login", { replace: true });
		}
	};

	return (
		<div className="logout__container">
			<h1 className="logout__title">
				로그아웃 하시겠습니까?
			</h1>
			<button
				className="logout__button"
				onClick={handleLogout}
				disabled={isLoading}>
				{isLoading ? "로그아웃 중..." : "로그아웃"}
			</button>
		</div>
	);
};

export default Logout;
